<template>
<div class="page page_videolist">
    <van-tabs class="video_vantab" v-model="type" line-width=".7rem" @change="changeType">
        <van-tab title="视频" name="video"></van-tab>
        <van-tab title="直播" name="live"></van-tab>
        <!-- <van-tab title="回放" name="posvideo"></van-tab> -->
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<!-- 视频 -->
        <van-list v-model="videoPage.loading" ref="videoListCheck" :finished="videoPage.finished" finished-text="没有更多了" @load="getData" class="cn_ul" :style="{display: type == 'video' ? 'block' : 'none'}" :immediate-check="false">
            <div class="video_list_item clearfix" v-for="(item,key) in videoList" :key='key' @click="goVideoDetail(item)">
                <div class="info">
                    <div class="info_t">
                        <div class="title slh">{{ item.title }}</div>
                        <!-- <div class="desc slh" v-html="item.describe.replace(/<[^>]*>/g,'')"></div> -->
                        <div class="desc slh">{{ item.describe_new }}</div>
                    </div>
                    <div class="price">
						<span class="discount_price" v-if="item.is_charge">¥{{ item.prices }}</span>
						<span class="free" v-else>免费</span>
						<!-- <span class="original_price">¥89.00</span> -->
					</div>
                </div>
                <div class="tu">
                    <div class="pos_flag" v-if="item.pos_flag == 1"></div>
                    <img :src="item.thumb != null && item.thumb !='' ? imageUrl+item.thumb :'' " alt="" class="">
                </div>
            </div>
        </van-list>
		<!-- 直播 -->
        <van-list v-model="livePage.loading" ref="liveListCheck" :finished="livePage.finished" finished-text="没有更多了" @load="getData" class="cn_ul" :style="{display: type == 'live' ? 'block' : 'none'}" :immediate-check="false">
            <div class="zhibo_list_item" @click="goLiveDetail(living.id)" v-for="living in liveList" :key="living.id">
                <div class="tu">
                    <img :src="living.thumb != null && living.thumb !='' ? imageUrl+living.thumb : '' " alt="" class="">
                    <!-- <div class="tag">{{living.live_status==0?'暂停':living.live_status==1?'直播中':'预告'}}</div> -->
					<div class="tag">{{living.live_status_name}}</div>
                </div>
                <div class="info">
                    <div class="title">{{living.title}}</div>
                </div>
            </div>
        </van-list>
		<!-- 回放 -->
        <van-list v-model="posvideoPage.loading" ref="posvideoListCheck" :finished="posvideoPage.finished" finished-text="没有更多了" @load="getData" class="cn_ul" :style="{display: type == 'posvideo' ? 'block' : 'none'}" :immediate-check="false">
            <div class="video_list_item clearfix" v-for="(item,key) in posvideoList" :key="key" @click="goPosVideoDetail(item.id)">
                <div class="info">
                    <div class="info_t">
                        <div class="title slh">{{ item.liveroom.title }}</div>
                        <div class="desc slh" v-html="item.liveroom.describe.replace(/<[^>]*>/g,'')"></div>
                        <!-- <div class="desc slh">{{ item.describe }}</div> -->
                    </div>
                    <!-- <div class="price">
                            <span class="discount_price">¥80.00</span>
                            <span class="original_price">¥89.00</span>
                        </div> -->
                </div>
                <div class="tu">
                    <div class="pos_flag" v-if="item.pos_flag == 1"></div>
                    <img :src="item.liveroom.thumb != null && item.liveroom.thumb !='' ? imageUrl+item.liveroom.thumb : '' " alt="" class="">
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    <!-- <div class="cn tuijian">
            <div class="cn_ul">
                <div class="cn_li">
                    <div class="info">
                        <div class="info_t">
                            <div class="title slh">【非遗技艺展示】剪纸情缘剪纸情缘剪纸情缘【非遗技艺展示】剪纸情缘剪纸情缘剪纸情缘【非遗技艺展示】剪纸情缘剪纸情缘剪纸情缘</div>
                            <div class="desc slh">始终秉承安溪百年古法制茶技艺精髓</div>
                        </div>
                        <div class="price">
                            <span class="discount_price">¥80.00</span>
                            <span class="original_price">¥89.00</span>
                        </div>
                    </div>
                    <div class="tu">
                        <img :src="publicPath+'statics/images/temp/tu01.png'" alt="" class="">
                    </div>
                </div>

            </div>
        </div> -->
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.imgPath,
            token: '',
            videoPage: {
                page: 1,
                size: 10,
                loading: false,
                finished: false,
                refreshing: false,
            },
            livePage: {
                page: 1,
                size: 10,
                loading: false,
                finished: false,
                refreshing: false,
            },
            posvideoPage: {
                page: 1,
                size: 10,
                loading: false,
                finished: false,
                refreshing: false,
            },
            refreshing: false,
            videoList: [], // 视频列表
            liveList: [], // 直播列表
            posvideoList: [], // 视频列表
            type: null, // 当前显示的列表类型   video/live/posvideo
            videoScrollTop: 0,
            liveScrollTop: 0,
            posvideoScrollTop: 0,
        };
    },
    watch: {
        type(newval, oldval) {
            console.log('type==============', newval)
            this.type = newval;
            this.onRefresh()
        }
    },
    activated: function () {
        console.log('type=========activated=====', this.type)
        this.type = this.$route.params.type;
        window.addEventListener("scroll", this.getScroll);
    },
    created: function () {
        console.log(123)
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '视频直播',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
                var memberParams = {
                    data: {
                        'notCallLogin': 1,
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            
                        } else {
                            this.token = "";
                        }
                        // this.onRefresh()
                        // this.getDetail();
                    }
                );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '视频直播 发现精彩',
                        detail: '更多精彩正在直播中，欢迎围观！\n点击这里，直达直播间！\n直播正在火热进行中！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'shipin.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
            this.getShareData()
			// this.getDetail();
        }
        // this.onRefresh()
        // this.type = this.$route.params.type;
        // window.addEventListener("scroll", this.getScroll);
    },
    // mounted(){
    //     this.onRefresh()
    // },
    methods: {
        // 获取数据
        getData() {
            switch (this.type) {
                case 'video': {
                    if (this.videoPage.finished == true) {
                        this.videoPage.loading = false;
                        return;
                    }
                    this.$api.living.livevideoList({
                        page: this.videoPage.page,
                        size: this.videoPage.size
                    }).then(res => {
                        if (res.code == 200) {
                            // this.videoList = res.result;
                            if (this.refreshing) {
                                this.refreshing = false;
                            }

                            if (res.result.length == 0) {
                                this.videoPage.finished = true;
                            }
                            this.videoList = this.videoList.concat(res.result);
                            this.videoPage.loading = false;
                            this.videoPage.page++;
                        }
                    });
                };
                break;
            case 'live': {
                if (this.livePage.finished == true) {
                    this.livePage.loading = false;
                    return;
                }
                this.$api.living.livingList({
                    page: this.livePage.page,
                    size: this.livePage.size
                }).then(res => {
                    if (res.code == 200) {
                        // this.liveList = res.result;
                        if (this.refreshing) {
                            this.refreshing = false;
                        }

                        if (res.result.length == 0) {
                            this.livePage.finished = true;
                        }
                        if (this.livePage.page == 1) {
                            this.liveList = []
						}
						var list = res.result
						for(var i in list){
							var item = list[i]
							if(item.live_status == 0){
								item.live_status_name = '暂停'
							}else if(item.live_status == 1){
								var currentTime = new Date()
								var roomStartTime = new Date(item.open_room)
								var roomEndTime = new Date(item.close_room)
								if(currentTime < roomStartTime){
									item.live_status_name = '未开始'
								}else if(currentTime >= roomStartTime && currentTime <= roomEndTime){
									item.live_status_name = '直播中'
								}else{
									item.live_status_name = '结束'
								}
							}else{
								item.live_status_name = '预告'
							}
						}
                        this.liveList = this.liveList.concat(list);
                        this.livePage.loading = false;
                        this.livePage.page++;
                    }
                })
            };
            break;
            case 'posvideo': {
                    if (this.posvideoPage.finished == true) {
                        this.posvideoPage.loading = false;
                        return;
                    }
                    this.$api.living.posvideoList({
                        page: this.posvideoPage.page,
                        size: this.posvideoPage.size
                    }).then(res => {
                        if (res.code == 200) {
                            // this.posvideoList = res.result;
                            if (this.refreshing) {
                                this.refreshing = false;
                            }
                            if (res.result.length == 0) {
                                this.posvideoPage.finished = true;
                            }
                            this.posvideoList = this.posvideoList.concat(res.result);
                            this.posvideoPage.loading = false;
                            this.posvideoPage.page++;
                        }
                    });
                };
                break;
            }

        },
        // 切换分类
        changeType(name, title) {
            console.log(name, title)
            let that = this;
            switch (that.type) {
                case 'video': {
                    // that.videoPage.loading = true;
                    that.$refs.videoListCheck.check();
                    setTimeout(function () {
                        $(window).scrollTop(that.videoScrollTop);
                    }, 1);
                };
                break;
            case 'live': {
                // that.livePage.loading = true;
                that.$refs.liveListCheck.check();
                setTimeout(function () {
                    $(window).scrollTop(that.liveScrollTop);
                }, 1);
            };
            break;
            case 'posvideo': {
                    // that.videoPage.loading = true;
                    that.$refs.posvideoListCheck.check();
                    setTimeout(function () {
                        $(window).scrollTop(that.posvideoScrollTop);
                    }, 1);
                };
                break;
            }
            // console.log('切换 start')
            // console.log('videoScroll:',that.videoScrollTop,'liveScroll:',that.liveScrollTop)
            // console.log('切换 end')
            // this.getData();

        },
        onRefresh() {
            // 清空列表数据

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            console.log(this.type)
            switch (this.type) {
                case 'video': {
                    this.videoList = [];
                    this.videoPage.page = 1;
                    this.videoPage.finished = false;
                    this.videoPage.refreshing = false;
                    this.videoPage.loading = true;
                };
                break;
                case 'live': {
                    this.liveList = [];
                    this.livePage.finished = false;
                    this.livePage.refreshing = false;
                    this.livePage.page = 1;
                    this.livePage.loading = true;
                };
                break;
                case 'posvideo': {
                    this.posvideoList = [];
                    this.posvideoPage.page = 1;
                    this.posvideoPage.finished = false;
                    this.posvideoPage.refreshing = false;
                    this.posvideoPage.loading = true;
                };
                break;
            }
            this.getData();
        },
        onVideoRefresh() {
            // 清空列表数据

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.videoPage.loading = true;
            this.videoPage.page = 1;
            this.videoPage.loading = false;
            this.videoPage.finished = false;
            this.videoPage.refreshing = false;
            this.videoList = [];
            // this.getData();
        },
        onLiveRefresh() {
            // 清空列表数据

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.livePage.loading = true;
            this.livePage.page = 1;
            this.livePage.loading = false;
            this.livePage.finished = false;
            this.livePage.refreshing = false;
            this.liveList = [];
            // this.getData();
        },
        onPosVideoRefresh() {
            // 清空列表数据

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.posvideoPage.loading = true;
            this.posvideoPage.page = 1;
            this.posvideoPage.loading = false;
            this.posvideoPage.finished = false;
            this.posvideoPage.refreshing = false;
            this.posvideoList = [];
            // this.getData();
        },
        //监听滚动
        getScroll() {
            switch (this.type) {
                case 'video': {
                    this.videoScrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop;
                    if (!!document.documentElement.scrollTop) {
                        this.videoScrollTop = document.documentElement.scrollTop;
                    }
                };
                break;
            case 'live': {
                this.liveScrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                if (!!document.documentElement.scrollTop) {
                    this.liveScrollTop = document.documentElement.scrollTop;
                }
            };
            break;
            case 'posvideo': {
                    this.posvideoScrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop;
                    if (!!document.documentElement.scrollTop) {
                        this.posvideoScrollTop = document.documentElement.scrollTop;
                    }
                };
                break;
            }
            // console.log('videoScroll:',this.videoScrollTop,'liveScroll:',this.liveScrollTop)

        },
        // 跳直播详情
        goLiveDetail(id) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/zhibo/detail?id=' + id
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                that.$router.push({
                    path: `/zhibo/detail`,
                    query: {
                        id: id
                    }
                })
            }
        },
        // 跳视频详情
        goVideoDetail(item) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/video/detail?id=' + item.id + '&is_charge='+ item.is_charge + '&prices=' + item.prices
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                that.$router.push({
                    path: `/video/detail`,
                    query: {
						id: item.id,
						is_charge: item.is_charge,
						prices: item.prices
                    }
                })
            }

            
        },
        // 跳视频回放详情
        goPosVideoDetail(id) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/posvideo/detail?id=' + id
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                that.$router.push({
                    path: `/posvideo/detail`,
                    query: {
                        id: id
                    }
                })
            }

            
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '视频直播 发现精彩', // 分享标题
                    desc: '更多精彩正在直播中，欢迎围观！\n点击这里，直达直播间！\n直播正在火热进行中！', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'shipin.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
